import React from "react";
import { Dropdown } from "react-bootstrap";
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from "prop-types";
import useUserAccount from "../hooks/useUserAccount";

const messages = defineMessages({
    switch_company: {
        id: "Vaihda yritystiliä",
        defaultMessage: "Vaihda yritystiliä"
    }
});

const MenuCompanySelect = (props) => {
    const { userCompanyName, userName, userInitCompanyAuthentication, userHasAccount } = useUserAccount();
    const lng = props.intl.formatMessage;

    const handleCompanyChange = async () => {
        const url = await userInitCompanyAuthentication()
        window.location.replace(url);
    }

    if (!userHasAccount) {
        return userCompanyName();
    }

    return (
        <Dropdown id='menu-company-select'>
            <Dropdown.Toggle variant='tertiary-menu'>
                {userCompanyName()}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item disabled>
                    {userName()}
                </Dropdown.Item>
                <Dropdown.Item disabled>
                    <strong>{userCompanyName()}</strong>
                </Dropdown.Item>
                <Dropdown.Item onClick={handleCompanyChange}>
                    {lng(messages.switch_company)}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    )
}

MenuCompanySelect.propTypes = {
    'intl': PropTypes.object.isRequired
};

export default injectIntl(MenuCompanySelect);
